import styled from 'styled-components/macro';

export const ScTeacherItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-left: 4px;
`;
